<template>
  <div v-if="bindTicket && bookingContactInfo" class="order-card">
    <div class="order-card-top">
      <div class="order-title">
        <img src="../../assets/order_detail_ship_ico.png" alt="">
        {{bindTicket.shipName}}
      </div>
      <div class="flex-between-box order-info">
        <div class="list-box">
          <div class="list-hd">舱房号</div>
          <div class="list-bd price-color">{{bindTicket.stateroomNumber}}</div>
        </div>
        <div class="list-box">
          <div class="list-hd">时长</div>
          <div class="list-bd">{{bindTicket.routeNights}}</div>
        </div>
        <div class="list-box">
          <div class="list-hd">日期</div>
          <div class="list-bd time">{{bindTicket.sailDateBegin}}-{{bindTicket.sailDateEnd}}</div>
        </div>
      </div>
      <div class="order-stroke">
        <div class="icon">
          <img src="../../assets/order_detail_address_ico.png" alt="">
        </div>
        <p class="text">{{bindTicket.cruiseName}}</p>
      </div>
      <div class="order-number">订单号：{{bindTicket.bookingId}}</div>
    </div>
    <div class="ticket-border" v-show="showOrder"></div>
    <div class="contacts-module" v-show="showOrder">
      <h3 class="module-title">联系人信息</h3>
      <privacy-button class="btn-privacy" @switch="handleSwitch"></privacy-button>
      <ul class="contacts-form" :class="{'is-payer': payerDisabled}">
        <li>
          <div class="title required">联系人：</div>
          <div class="content">
            <template v-if="payerDisabled">{{bookingContactInfo.bookingContactName}}</template>
            <template v-else>
              <van-field
                  v-model="contacts.bookingContactName"
                  label=""
                  placeholder="请输入联系人"
                  @blur="bookingContactNameBlur"
                  class="text-van-field"
                  clearable
                  @focus="textFocus"
                  id="bookingContactName"
              />
            </template>
          </div>
        </li>
        <li>
          <div class="title required">手机号：</div>
          <div class="content">
            <template v-if="payerDisabled">{{bookingContactInfo.callingCode}}-{{bookingContactInfo.telephone}}</template>
            <template v-else>
              <van-field
                  readonly
                  clickable
                  :value="contacts.callingCodeValue"
                  label=""
                  @click="showCountriesPicker = true"
                  placeholder="请选择国家"
                  class="select-van-field select-box"
                  id="callingCodeValue"
              />
              <van-popup v-model="showCountriesPicker" position="bottom">
                <van-picker
                    show-toolbar
                    value-key="text"
                    :columns="countries"
                    :default-index="contacts.callingCodeValueIndex"
                    @confirm="onCountriesConfirm"
                    @cancel="showCountriesPicker = false"
                    id="callingCodeValueIndex"

                />
              </van-popup>
              <van-field
                  v-model="contacts.telephone"
                  label=""
                  class="text-box text-van-field"
                  placeholder="请输入手机号"
                  maxlength="11"
                  @blur="telephoneBlur"
                  clearable
                  id="telephone"
                  @focus="textFocus"
              />
            </template>
          </div>
        </li>
        <li>
          <div class="title fc-letter required">Email：</div>
          <div class="content">
            <template v-if="payerDisabled">{{bookingContactInfo.email}}</template>
            <template v-else>
              <van-field
                  v-model="contacts.email"
                  label=""
                  placeholder="请输入邮箱"
                  @blur="emailBlur"
                  class="text-van-field"
                  clearable
                  id="email"
                  @focus="textFocus"
              />
            </template>
          </div>
        </li>
      </ul>
    </div>
    <div class="ticket-border" v-show="showOrder"></div>
    <div class="order-card-bottom" v-show="showOrder">
      <div class="payer" v-if="payerDisabled">
        <span>预订支付人：</span>{{bindTicket.pinyinLastName}} {{bindTicket.pinyinFirstName}}
      </div>
      <van-field
        v-else
        readonly
        clickable
        :value="value"
        label="预订支付人："
        @click="showPicker = true"
        placeholder="请选择预订支付人"
        class="select-van-field"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
        show-toolbar
        value-key="pingyingName"
        :columns="payList"
        :default-index="valueIndex"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        />
      </van-popup>
    </div>
    <div class="empty-shopping-cart" v-show="showGuide">
      <div class="text01">您还没有已提交的活动订单</div>
      <div class="text02">请选择产品后进入购物车结算</div>
      <van-button block class="btn-linear-gradient" @click="goNext">马上去看看</van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import PrivacyButton from "@/components/PrivacyButton";
export default {
  name: 'OrderCard',
  components: {PrivacyButton},
  props: {
    payerDisabled: {
      type: Boolean,
      default: false
    },
    orderDisabled: {
      type: Boolean,
      default: false
    },
    submitOrder: {
      type: Boolean,
      default: false
    },
    MajorGuestID: Number,
    payList: {
      type: Array,
      default () {
        return []
      }
    },
    bookingContact: {
      type: Object,
      default: null
    },
    displayOrder: {
      type: Function
    },
    countries: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  watch: {
    payList (val) {
      const listData = val
      console.log(listData)
      for (let index = 0; index < listData.length; index++) {
        listData[index].pingyingName = listData[index].pinYinLastName + listData[index].pinYinFirstName

        if (listData[index].id === this.MajorGuestID) {
          this.value = listData[index].pinYinLastName + listData[index].pinYinFirstName
          this.valueIndex = index;
        }
      }
    },
    MajorGuestID (val) {
      for (let index = 0; index < this.payList.length; index++) {
        if (this.payList[index].id === val) {
          this.value = this.payList[index].pinYinLastName + this.payList[index].pinYinFirstName
        }
      }
    },
    bookingContact:{
      //监听隐私按钮切换,联系人信息更新
      handler(newVal) {
        this.contacts = Object.assign({}, newVal)
        this.handleName()
        this.handleCallingCode()
        console.log('info change')
        console.log('this.contacts',this.contacts)
      },
      deep: true

    }

  },

  computed: mapState(['bindTicket', 'bookingContactInfo','isMaskValue']),

  data () {
    return {
      value: '',
      valueIndex: -1,
      route: '',
      showGuide: false,
      showOrder: false,
      showPicker: false,
      showCountriesPicker: false,
      contacts: {
        callingCodeValueIndex: -1,
        callingCodeValue: null,
        callingCode: null,
        bookingContactName: null,
        telephone: null,
        email: null
      },
      callingCodeValue: null
    }
  },
  created () {
    this.contacts = Object.assign({}, this.bookingContact);
    this.handleName()
    this.handleCallingCode()
    // this.value = this.columns[0]
  },
  async mounted () {
    const { isFromCart } = this.$route.query
    if (isFromCart === 'true') {
      this.showOrder = true
      this.displayOrder()
    } else {
      if (!this.orderDisabled && !this.submitOrder) {
        this.getOrderState()
      }
      if (this.submitOrder) {
        this.showOrder = true
      }
    }
  },

  methods: {
    textFocus(e){
      const isMaskValue =this.isMaskValue
      const id=e.target.id
      console.log('focus',id)
      this.contacts[id]=isMaskValue?"":this.contacts[id]
    },
    goNext () {
      this.$router.push(this.route)
    },
    async getOrderState () {
      showLoading('加载中...')
      const { errCode, errMsg, data } = await api.checkOrderStatus()
      hideLoading()
      if (errCode === 0) {
        if (data.orderStatus === 1) {
          this.showOrder = true
          this.displayOrder()
        } else {
          this.showGuide = true
          if (data.hasOrder) {
            this.route = '/page_shopping_cart'
          } else {
            this.route = '/'
          }
        }
      } else {
        showAlert(errMsg || '检查失败，请稍后重试')
      }
    },
    onConfirm (value) {
      this.value = value.pinYinLastName + value.pinYinFirstName
      this.showPicker = false
      this.$emit('checkName', value.id)
    },
    onCountriesConfirm (value) {
      this.contacts.callingCodeValue = value.text;
      this.showCountriesPicker = false;
      this.$emit('checkContacts', {val: value.callingCode.replace("+", ""), key: 'callingCode'})
    },
    telephoneBlur() {
      this.$emit('checkContacts', {val:this.contacts.telephone, key: 'telephone'})
    },
    emailBlur() {
      this.$emit('checkContacts', {val:this.contacts.email, key: 'email'})
    },
    bookingContactNameBlur() {
      this.$emit('checkContacts', {val:this.contacts.bookingContactName, key: 'bookingContactName'})
    },
    handleSwitch(){
        this.$emit('switch')
    },
    handleCallingCode(){
      if (this.countries.length > 0) {
        this.countries.forEach((row)=> {
          row.text = `${row.countryName}(${row.callingCode})`;
        });
        let countriesFilter = this.countries.filter((row, index)=> {
          if(row.callingCode === `+${this.contacts.callingCode}`) {
            this.contacts.callingCodeValueIndex = index;
            return row;
          }
        });
        let currentCountries = countriesFilter.length > 0 ? countriesFilter[0] : this.countries[0];
        this.contacts.callingCodeValue = `${currentCountries.countryName}(${currentCountries.callingCode})`
      }
    },
    handleName(){
      if (this.payList.length > 0) {
        for (let index = 0; index < this.payList.length; index++) {
          this.payList[index].pingyingName = this.payList[index].pinYinLastName + this.payList[index].pinYinFirstName
          if (this.payList[index].id === this.MajorGuestID) {
            this.value = this.payList[index].pinYinLastName + this.payList[index].pinYinFirstName;
            this.valueIndex = index;
          }
        }
        if(this.valueIndex < 0) {
          this.value = this.payList[0].pinYinLastName + this.payList[0].pinYinFirstName;
          this.valueIndex = 0;
        }
      }
    }


  }
}
</script>

<style lang="less" scoped>
.order-card{
  font-size: 24px;
  background-color: #ffffff;
  text-align: center;
  border-radius: 6px;
  overflow: hidden;
  .order-title{
    font-size: 36px;
    color: @main-color;
    line-height: 42px;
    padding-bottom: 50px;
    img{
      display: block;
      width: 46px;
      height: 50px;
      margin: 0 auto 20px;
    }
  }
  .order-card-top{
    padding: 50px 24px 18px;
    .list-box{
      border-right: 1px solid @main-gray5;
      padding-right: 50px;
      font-size: 30px;
      &:last-child{
        border: none;
        padding-right: 0px;
      }
      .list-hd{
        color: @main-gray4;
        margin-bottom: 10px;
      }
      .price-color {
        color: @second-color;
      }
      .time{
        font-size: 24px;
        line-height: 1.8;
      }
    }
    .order-stroke{
      display: flex;
      padding: 0 12px 0 6px;
      font-size: 20px;
      color: @main-color;
      background-color: #e8ecef;
      border-radius: 23px;
      margin-top: 32px;
      text-align: left;
      align-items: center;
      .icon {
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 56px;
        height: 46px;
      }
      img{
        width: 22px;
      }
      .text {
        padding: 9px 0;
        color: #1174b8;
      }
    }
    .order-number{
      line-height: 98px;
      color: @main-gray4;
    }
  }
  .ticket-border{
    width: 100%;
    height: 0;
    border-bottom: 2px dashed #f0f0f0;
    position: relative;
    &::after,&::before{
      content: '';
      width: 35px;
      height: 35px;
      display: block;
      position: absolute;
      background-color: #f0f0f0;
      border-radius: 50%;
      top: -17.5px;
    }
    &::after{
      right: -17.5px;
    }
    &::before{
      left: -17.5px;
    }
  }
  .order-card-bottom {
    display: flex;
    align-items: center;
    height: 142px;
    ::v-deep .van-cell {
      &:after{
        display: none;
      }
    }
    .payer {
      padding: 0 30px;
      font-size: 24px;
      color: #666;
      span {
        color: #000;
      }
    }
  }
  /deep/.van-field__label {
    width: auto;
    font-size: .24rem;
  }
  /deep/.van-field__body {
    border: 1px solid #eaeaea;
    padding: 0 .2rem;
    position: relative;
    border-radius: 0.06rem;
    .van-field__control{
      color: #242e65;
      font-size: .24rem;
    }
  }
}

.contacts-module {
  padding: 15px 31px 25px;
  position: relative;
  .btn-privacy{
    position: absolute;
    top: 10px;
    right: 10px;
  }
  & .module-title {
    padding: .2rem 0 0;
    text-align: left;
  }
}
.contacts-form {
  & > li {
    padding: 14px 0;
    overflow: hidden;
    text-align: left;
    &:first-child {
      padding-bottom: 0;
    }
    & .title {
      float: left;
      width: 1.2rem;
      line-height: .5rem;
      &.fc-letter {
        letter-spacing: 2px;
      }
      &.required::before {
        content: "*";
        margin-right: 0.05rem;
        color: #ff0000;
      }
    }
    & .content {
      display: flex;
      overflow: hidden;
      line-height: .5rem;
      & .select-box {
        width: 40%;
      }
      & .text-box {
        width: 60%;
        margin-left: .1rem;
      }
    }
    & /deep/ .van-cell {
      padding: 0
    }
  }

  &.is-payer {
    & > li {
      padding: 8px 0;
      &:first-child {
        padding-top: 16px;
      }
      & .title {
        line-height: .35rem;
      }
      & .content {
        line-height: .35rem;
        display: block;
        word-wrap: break-word;
        color: #666666;
      }
    }
  }
}
.select-van-field {
  /deep/ .van-field__body {
    border:1px solid #eaeaea;
    padding: 0 .3rem 0 .2rem;
    & .van-field__control {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    &:after {
      content: "\F007";
      display: block;
      position: absolute;
      right: .1rem;
      top: .1rem;
      font: normal normal normal 14px/1 "vant-icon";
      font-size: inherit;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      font-size: .20rem;
    }
  }
}
.text-van-field {
  /deep/ .van-field__clear,
  /deep/ .van-field__right-icon {
    padding: 0 2px 0 8px;
  }
}
.empty-shopping-cart{
  padding: 60px 0px;
  font-size: 24px;
  text-align: center;
  color: @main-gray3;
  .text01{
    font-size: 30px;
    color: @main-gray1;
    margin-bottom: 10px
  }
  .text02{
    margin-bottom: 40px;
  }
  /deep/ .van-button--block{
    width: 60%;
    margin: 0 auto;
    color: @main-gray2;
  }
}
</style>
